export default {
  mapAgentsList({ data }) {
    return data.map(({ attributes }) => attributes.title).sort();
  },
};
